export default {
    prodSga2pictograms: {
        "suggestedPictograms": [],
        "customPictograms": []
    }
};
